import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';
import { getServizio } from '../services/api';
import { Container, Card, Row, Col, Spinner, Alert, Button } from 'react-bootstrap';

const ServiziDetail = () => {
  const [servizio, setServizio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const location = useLocation();
  const backTo = location.state?.from || '/servizi';
  const tornaIndietro = useTornaIndietro('/servizi');

  useEffect(() => {
    const fetchServizioData = async () => {
      try {
        setLoading(true);
        const response = await getServizio(id);
        setServizio(response.data);
      } catch (err) {
        setError('Errore nel caricamento del servizio.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchServizioData();
  }, [id]);

  const renderField = (label, value) => (
    <p><strong>{label}:</strong> {value || 'N/D'}</p>
  );

  if (loading) return <Spinner animation="border" />;
  if (error) return <Alert variant="danger">{error}</Alert>;
  if (!servizio) return <Alert variant="warning">Servizio non trovato.</Alert>;

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Dettaglio Servizio: {servizio.titolo_servizio || servizio.descrizione}</h2>
        <div>
          <Button variant="secondary" onClick={tornaIndietro} className="me-2">
            Torna alla Lista
          </Button>
          <Button variant="warning" as={Link} to={'/servizi/edit/' + id} className="me-2">Modifica</Button>
          <Button variant="info" as={Link} to={'/servizi/print/' + id}>Stampa</Button>
        </div>
      </div>

      {/* DETTAGLI SERVIZIO */}
      <Card className="mb-4">
        <Card.Header>DETTAGLI SERVIZIO</Card.Header>
        <Card.Body>
            <Row>
                <Col>{renderField('SKU', servizio.sku)}</Col>
                <Col>{renderField('Categoria', servizio.categoria)}</Col>
            </Row>
            {renderField('Titolo Servizio', servizio.titolo_servizio)}
            {servizio.immagine_url && (
                <div className="mb-3">
                    <strong>Immagine:</strong>
                    <img src={servizio.immagine_url} alt="Immagine Servizio" style={{ maxWidth: '200px', height: 'auto', display: 'block', marginTop: '10px' }} />
                </div>
            )}
            {renderField('Descrizione', servizio.descrizione)}
        </Card.Body>
      </Card>

      {/* PREZZI E MAGAZZINO */}
      <Card className="mb-4">
        <Card.Header>PREZZI E MAGAZZINO</Card.Header>
        <Card.Body>
            <Row>
                <Col>{renderField('Prezzo', servizio.prezzo ? '€ ' + servizio.prezzo.toFixed(2) : 'N/D')}</Col>
                <Col>{renderField('Costo', servizio.costo ? '€ ' + servizio.costo.toFixed(2) : 'N/D')}</Col>
                <Col>{renderField('IVA', servizio.iva ? servizio.iva + '%' : 'N/D')}</Col>
            </Row>
        </Card.Body>
      </Card>

      {/* DETTAGLI PREVENTIVO */}
      <Card className="mb-4">
        <Card.Header>DETTAGLI PREVENTIVO</Card.Header>
        <Card.Body>
            <Row>
                <Col>{renderField('Prezzo Indicativo "Da"', servizio.prezzo_indicativo_da ? '€ ' + servizio.prezzo_indicativo_da.toFixed(2) : 'N/D')}</Col>
                <Col>{renderField('Unità di Misura Base', servizio.unita_misura_base)}</Col>
                <Col>{renderField('Costo Unitario Base', servizio.costo_unitario_base ? '€ ' + servizio.costo_unitario_base.toFixed(2) : 'N/D')}</Col>
            </Row>
            {renderField('Attivo', servizio.attivo ? 'Sì' : 'No')}
            {servizio.opzioni_configurabili_json && (
                <div className="mb-3">
                    <strong>Opzioni Configurabili (JSON):</strong>
                    <pre style={{ backgroundColor: '#f8f9fa', padding: '10px', borderRadius: '5px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                        {JSON.stringify(JSON.parse(servizio.opzioni_configurabili_json), null, 2)}
                    </pre>
                </div>
            )}
        </Card.Body>
      </Card>

      {/* INFORMAZIONI AGGIUNTIVE */}
      <Card className="mb-4">
        <Card.Header>INFORMAZIONI AGGIUNTIVE</Card.Header>
        <Card.Body>
            <Row>
                <Col>{renderField('Data Creazione', servizio.data_creazione ? new Date(servizio.data_creazione).toLocaleString() : 'N/D')}</Col>
                <Col>{renderField('Ultimo Aggiornamento', servizio.data_aggiornamento ? new Date(servizio.data_aggiornamento).toLocaleString() : 'N/D')}</Col>
            </Row>
        </Card.Body>
      </Card>

    </Container>
  );
};

export default ServiziDetail;
